<template>
  <swiper
    class="sso-pc-swiper swiper-no-swiping"
    ref="mySwiper"
    :options="swiperOptions"
  >
    <swiper-slide v-for="(item, index) in imgList" :key="index">
      <a
        v-if="item.Href"
        :href="item.Href"
        target="_blank"
        :style="{ backgroundImage: 'url(' + item.ImgUrl + ')' }"
      >
        <!-- <img :style="{ backgroundImage: 'url(' + item.ImgUrl + ')' }" /> -->
      </a>
      <div
        class="no-href-content"
        v-else
        :style="{ backgroundImage: 'url(' + item.ImgUrl + ')' }"
      ></div>
    </swiper-slide>

    <div class="swiper-pagination" slot="pagination"></div>
    <!-- <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div> -->
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import staticUrl from "../../assets/img/banner.jpg";

// import style
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    imgList: {
      type: Array,
    },
  },
  data: function () {
    const _self = this;
    return {
      swiperOptions: {
        // autoHeight: true,
        freeMode: true,
        loop: true,
        speed: 1500,
        mousewheelControl: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,
        },
        effect: "fade", // 渐变
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
        nextButton: ".swiper-button-next", // 前进按钮的css选择器或HTML元素。
        prevButton: ".swiper-button-prev", // 后退按钮的css选择器或HTML元素。
        observeParents: true,
        observer: true,
        // on:{

        // }
      },
    };
  },
  methods: {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  mounted() {
    this.swiper.slideTo(1, 1000, false);
  },
  created() {
    // const restImgs = this.$http.getByThePictureImgs();
    // restImgs
    //   .then((res) => {
    //     if (Number(res.Code) === 200 && res.Data.Banners.length > 0) {
    //       this.imgList = res.Data.Banners;
    //     } else {
    //       console.warn(
    //         `首页轮播接口未返回数据或返回值为空:Banners:{imgUrl:url,Href:url}[]:${res.Data.Banners.length}`
    //       );
    //     }
    //   })
    //   .catch(function (e) {
    //     console.warn(e);
    //   });
  },
};
</script>

<style lang="scss" scoped>
@import "@css/style.scss";
[v-cloak] {
  display: none;
}

.sso-pc-swiper {
  /* flex-grow: 1;
  display: flex; */
  width: 100%;
  /* overflow: hidden; */
  a {
    display: inline-block;
    height: 100%;
    width: 100%;
    text-align: center;
    vertical-align: middle;
    background-repeat: no-repeat;
    /* background-origin: top; */
    background-position: top;
    background-size: cover;
    /* img {
      display: inline-block;
      vertical-align: middle;
      width: 100%;
      height: 100%;
      object-fit: cover;
      background-size: cover;
      background-repeat: no-repeat;
    }  */
  }
  .no-href-content {
    display: inline-block;
    height: 100%;
    width: 100%;
    text-align: center;
    vertical-align: middle;
    background-repeat: no-repeat;
    /* background-origin: top; */
    background-position: top;
    background-size: cover;
  }
}
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 20px;
}
.swiper-container/deep/ .swiper-pagination-bullet {
  width: px2rem(45 * 2);
  height: 3px;
  background: #9a9396;
  border-radius: 3px;
}
.swiper-container/deep/ .swiper-pagination-bullet-active {
  width: px2rem(45 * 3);
  height: 3px;
  background: #fff;
  border-radius: 3px;
}
/* .swiper-container/deep/ .swiper-button-next {
  background-image: url("../../assets/img/icons/right.png");
}
.swiper-container/deep/ .swiper-button-prev {
  background-image: url("../../assets/img/icons/left.png");
} */
.swiper-button-prev,
.swiper-button-next {
  cursor: pointer;
  top: 40%;
  width: 50px;
  height: 62px;
  background: rgba(0, 0, 0, 0.4) no-repeat center center;
  background-size: 17px 28px;
  color: #fff;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 24px;
}
.swiper-button-prev {
  left: 0;
}
.swiper-button-next {
  right: 0;
}
</style>
